module.exports = __webpack_public_path__ + "static/img/right-home-row-2.88a48f4b.png";